import { unzipSync } from "fflate";
import { codedError } from "./gltfPack";

export { codedError };

/** zip 內要忽略的項目：資料夾、macOS 附檔、隱藏檔。 */
const shouldSkip = (path) =>
  path.endsWith("/") || path.startsWith("__MACOSX/") || /(^|\/)\./.test(path);

/**
 * 解壓上限（預設值；Upload 頁會把 maxTotalBytes 設成上傳上限）。
 * fflate 的 filter 會在 inflate 每個 entry「之前」拿到 zip 中央目錄宣告的解壓後大小
 * （originalSize），所以在 filter 裡累加、超限就丟，配置的記憶體不會超過上限：
 * 高壓縮比的 zip bomb 在第一個 entry 就會被擋下，不會先解開 GB 級資料再檢查。
 */
export const ZIP_LIMITS = {
  maxEntries: 1000,
  maxTotalBytes: 100 * 1024 * 1024,
};

/**
 * 把 zip bytes 解成 { path, bytes }[]，路徑保留 zip 內的相對結構。
 * fflate 會依 zip 的 UTF-8 旗標正確還原中文檔名。
 * @throws {Error & { code: "OVER_SIZE" | "TOO_MANY_ENTRIES" }}
 */
export function unzipBytesToEntries(
  zipped,
  { maxEntries = ZIP_LIMITS.maxEntries, maxTotalBytes = ZIP_LIMITS.maxTotalBytes } = {},
) {
  let count = 0;
  let total = 0;
  const unzipped = unzipSync(zipped, {
    filter: ({ name, originalSize }) => {
      if (shouldSkip(name)) return false;
      count += 1;
      total += originalSize;
      if (count > maxEntries) {
        throw codedError("TOO_MANY_ENTRIES", `zip 內超過 ${maxEntries} 個檔案`);
      }
      if (total > maxTotalBytes) {
        throw codedError(
          "OVER_SIZE",
          `zip 解壓後超過 ${maxTotalBytes} bytes（到 ${name} 為止已宣告 ${total} bytes）`,
        );
      }
      return true;
    },
  });
  return Object.entries(unzipped).map(([path, bytes]) => ({ path, bytes }));
}

/** 瀏覽器用：使用者上傳的 .zip File → { path, bytes }[]。limits 同 unzipBytesToEntries。 */
export async function unzipToEntries(file, limits) {
  return unzipBytesToEntries(new Uint8Array(await file.arrayBuffer()), limits);
}
